import { matchValues } from '@shared/core/types/common';

const locale: OLO.Types.LINK_TYPE[] = ['contactUs', 'userAgreement', 'privacyPolicy'];

export const linkType = matchValues(...locale);
